import { SearchResultEnqueteJsEnv } from "./search_result_enquete_js_env";

export class SearchResultEnquete {
  constructor(private model: SearchResultEnqueteJsEnv) {
    this.model = { ...model };
  }

  getModel(): SearchResultEnqueteJsEnv {
    return {
      ...this.model
    };
  }

  setIsUseful(isUseful: boolean): void {
    this.model.isUseful = isUseful;
  }

  setEnqueteMessage(enqueteMessage: string): void {
    this.model.enqueteMessage = enqueteMessage;
  }

}
